import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Col, Form, FormFeedback, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import Icon from '../../../components/Icon';
import AppModal from '../../../components/Modal';
import { addOrganizationMember, getLoggedUser } from '../../../actions/api';
import * as types from '../../../constants/ActionTypes';
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withAddOrganizationMemberModal = (WrappedComponent) => connect(void 0, mapDispatchToProps)(withTranslation()(class AddOrganizationMemberModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            processing: false,
            organization: {},
            callback: () => void 0,
            emails: '',
            usersNotFound: [],
        };
        this.handleCloseModal = () => {
            this.setState({ open: false });
        };
        this.handleClick = (organization, callback) => {
            this.setState({
                open: true,
                processing: false,
                organization: organization,
                callback: callback || (() => void 0),
                emails: '',
                usersNotFound: [],
            });
        };
        this.handleSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            this.setState({
                processing: true,
            });
            let usersNotFound = [];
            const mails = this.state.emails.split(/[,;]/).map((email) => email.trim()), promises = mails.map((email) => this.props
                // @ts-expect-error TS2339: Property 'name' does not exist on type '{}'.
                .dispatch(addOrganizationMember(this.state.organization.name, email))
                .then((action) => {
                if (action.type !== types.ADD_ORGANIZATION_MEMBER_SUCCESS) {
                    usersNotFound.push(email);
                }
                return Promise.resolve();
            }));
            Promise.all(promises).then(() => {
                if (usersNotFound.length === promises.length) {
                    this.setState({
                        processing: false,
                        usersNotFound: usersNotFound,
                    });
                }
                else {
                    this.setState({
                        open: false,
                        processing: false,
                    });
                    this.props.dispatch(getLoggedUser()).then((action) => {
                        // @todo: dirty
                        if (action.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                            this.props.dispatch({
                                type: types.LOGGED_USER,
                                payload: action.response.data,
                            });
                        }
                    });
                    this.state.callback();
                }
            });
        };
        this.handleChange = (property, event) => {
            // @ts-expect-error TS2345: Argument of type is not assignable
            this.setState({
                [property]: event.target.value,
            });
        };
    }
    renderModal() {
        const { t } = this.props;
        return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('organizations.inviteMembers') }), _jsx(ModalBody, { children: _jsx(Form, { onSubmit: this.handleSubmit, children: _jsxs(FormGroup, { row: true, children: [_jsx(Label, { for: "name", sm: 2, children: t('organizations.emails') }), _jsxs(Col, { sm: 10, children: [_jsx(Input, { type: "textarea", name: "emails", id: "emails", value: this.state.emails, onChange: (event) => this.handleChange('emails', event), placeholder: t('organizations.emailsPlaceholder'), invalid: this.state.usersNotFound.length > 0, autoFocus: true }), this.state.usersNotFound.length === 0 ? null : (_jsx(FormFeedback, { children: t('organizations.usersNotFound', {
                                                users: this.state.usersNotFound.join(', '),
                                            }) }))] })] }) }) }), _jsxs(ModalFooter, { children: [_jsxs(Button, { color: "primary", onClick: this.handleSubmit, disabled: this.state.processing || !this.state.emails, children: [!this.state.processing ? null : (_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, className: "mr-2" })), t('organizations.invite')] }), _jsx(Button, { color: "light", onClick: this.handleCloseModal, children: t('cancel') })] })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onAddOrganizationMemberClick: this.handleClick }), !this.state.open ? null : _jsx(AppModal, { children: this.renderModal() })] }));
    }
}));
